import { AnyAction, combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import { events } from './events';
import { teamsStandings } from './teams';
import { user } from './user';
import { entities } from './entities';
import { flags } from './flags';
import { players } from './players';
import { practices } from './practices';
import { searches } from './searches';
import tableProperties from './tableProperties';
import { loading } from './loading';
import { games, playsIgnored } from './games';
import profiles from './profiles';
import { dataEvents } from './dataEvents';
import filters from './filters';
import { monitorData } from './monitor';
import manage from './manage';
import health from './health';
import { dataOps } from './dataOps';
import { CLEAN_ALL_STATE } from '../types';
import { dataPlayers } from './dataPlayers';
import { practiceFields } from './practiceFields';
import { processingStatus } from './processingStatus';
import { practiceDataUpdate } from './practiceDataUpdate';
import { customEvents, customAlerts, customSpeedAlerts } from './customEvents';
import { customTable } from './customTable';
import { playerNote} from './playerNotes';
import about from './about';
import { playerParticipationData } from './playerParticipation';
import { gameMeta } from './gameMeta';
import { intensities } from './intensities';
import { periodTypes } from './periodTypes';
import { users } from './users';
import { roles } from './roles';
export const history = createBrowserHistory();

export const appReducer = combineReducers({
  // Data
  user,
  events,
  practices,
  games,
  dataEvents,
  players,
  dataPlayers,
  dataTeams: teamsStandings,
  entities,
  profiles,
  monitorData,
  health,
  dataOps,
  processingStatus,
  manage,
  practiceDataUpdate,
  customEvents,
  customTable,
  customAlerts,
  customSpeedAlerts,
  playsIgnored,
  playerParticipationData,
  gameMeta,
  intensities,
  periodTypes,
  // User Management
  users,
  roles,
  // App Utils
  loading,
  searches,
  flags,
  tableProperties,
  filters,
  // Others
  router: connectRouter(history),
  practiceFields,
  about,
  playerNote
});

export type RootState = ReturnType<typeof appReducer>;

export default (state: RootState | undefined, action: AnyAction) => {
  if (action.type === CLEAN_ALL_STATE) {
    state = undefined;
  }
  return appReducer(state, action);
};
